import React from 'react';
import NavAdmin from '../nav-admin/nav-admin';
import DirectEmailIcon from './../../assets/images/svg-icons-material-io/mail_lock_black_24dp.svg';

const HeaderEmails = () => (
  <header className="HeaderEmails" role="banner">
    <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar" aria-label="Direct email header bar with admin navigation">
        <div className="container w-max2">
            <h5 className="sp-mx" id="emails-header-title">
                <img src={ DirectEmailIcon } className="filter-white" alt="" aria-hidden="true" /> 
                <span className="spacer-margin2 v-set4" >Direct Emails</span>
            </h5>
            <NavAdmin />
        </div>
    </nav>
  </header>
);

export default HeaderEmails;
